import useTranslation from '../useTranslation';
import { DroneStatusUpdateRequestStatus } from 'generatedTypes/asset/models';
import { useState } from 'react';

import { CLAIM_ACTION, SUCCESS_VARIANT } from './constants';
import type { ModalActionKey, ModalConfig, Props, UseStatusModalReturn } from './types';

export { CLAIM_ACTION };

const ACTION_TO_STATUS: Record<ModalActionKey, DroneStatusUpdateRequestStatus> = {
    [CLAIM_ACTION]: DroneStatusUpdateRequestStatus.ENABLED,
    [DroneStatusUpdateRequestStatus.DISABLED]: DroneStatusUpdateRequestStatus.DISABLED,
    [DroneStatusUpdateRequestStatus.ENABLED]: DroneStatusUpdateRequestStatus.ENABLED,
    [DroneStatusUpdateRequestStatus.RELEASED]: DroneStatusUpdateRequestStatus.RELEASED
};

const useStatusModal = ({ onConfirm }: Props): UseStatusModalReturn => {
    const {
        CLAIM_AIRCRAFT_CONFIRMATION,
        CLAIM_BUTTON,
        DISABLE,
        DISABLE_AIRCRAFT_CONFIRMATION,
        DISABLE_AIRCRAFT_SUBTEXT,
        ENABLE,
        ENABLE_AIRCRAFT_CONFIRMATION,
        ENABLE_AIRCRAFT_SUBTEXT,
        RELEASE_AIRCRAFT_CONFIRMATION,
        RELEASE_AIRCRAFT_SUBTEXT,
        RELEASE_BUTTON
    } = useTranslation();

    const [pendingAction, setPendingAction] = useState<ModalActionKey | null>(null);

    const modalConfigMap: Record<ModalActionKey, ModalConfig> = {
        [CLAIM_ACTION]: {
            confirmText: CLAIM_BUTTON,
            confirmVariant: SUCCESS_VARIANT,
            text: CLAIM_AIRCRAFT_CONFIRMATION
        },
        [DroneStatusUpdateRequestStatus.DISABLED]: {
            confirmText: DISABLE,
            subText: DISABLE_AIRCRAFT_SUBTEXT,
            text: DISABLE_AIRCRAFT_CONFIRMATION
        },
        [DroneStatusUpdateRequestStatus.ENABLED]: {
            confirmText: ENABLE,
            confirmVariant: SUCCESS_VARIANT,
            subText: ENABLE_AIRCRAFT_SUBTEXT,
            text: ENABLE_AIRCRAFT_CONFIRMATION
        },
        [DroneStatusUpdateRequestStatus.RELEASED]: {
            confirmText: RELEASE_BUTTON,
            subText: RELEASE_AIRCRAFT_SUBTEXT,
            text: RELEASE_AIRCRAFT_CONFIRMATION
        }
    };

    const handleModalClose = () => {
        setPendingAction(null);
    };

    const handleModalConfirm = async () => {
        if (!pendingAction) {
            return;
        }

        try {
            await onConfirm(ACTION_TO_STATUS[pendingAction]);
        } finally {
            setPendingAction(null);
        }
    };

    const openModal = (action: ModalActionKey) => {
        setPendingAction(action);
    };

    return {
        handleModalClose,
        handleModalConfirm,
        isModalOpen: pendingAction !== null,
        modalConfig: pendingAction ? modalConfigMap[pendingAction] : null,
        openModal
    };
};

export default useStatusModal;
